import axios from 'axios';
import { ApiResult, ServiceResponse } from '../../OptimusRoutes/interfaces';
import { CommandDto } from '../modelProfile/modelProfile.dto';
import { CameraDto } from './camera.dto';

type CameraService = {
	get: (deviceId: number) => Promise<ServiceResponse<ApiResult<CameraDto[]>>>;
	create: (deviceId: number, body: Partial<CameraDto>) => Promise<ServiceResponse<Partial<CameraDto>>>;
	update: (
		deviceId: number,
		cameraId: number,
		body: Partial<CameraDto>
	) => Promise<ServiceResponse<Partial<CameraDto>>>;
	delete: (deviceId: number, cameraId: number) => Promise<void>;
	getCommands: (deviceId: number) => Promise<ServiceResponse<CommandDto[]>>;
};

const get = async (deviceId: number): Promise<ServiceResponse<ApiResult<CameraDto[]>>> => {
	const { data } = await axios.get<ServiceResponse<ApiResult<CameraDto[]>>>(`/v2/devices/${deviceId}/camera`);
	return data;
};

const create = async (deviceId: number, body: Partial<CameraDto>): Promise<ServiceResponse<Partial<CameraDto>>> => {
	const { data } = await axios.post<ServiceResponse<Partial<CameraDto>>>(`/v2/devices/${deviceId}/camera`, body);
	return data;
};

const update = async (
	deviceId: number,
	cameraId: number,
	body: Partial<CameraDto>
): Promise<ServiceResponse<Partial<CameraDto>>> => {
	const { data } = await axios.patch<ServiceResponse<Partial<CameraDto>>>(
		`/v2/devices/${deviceId}/camera/${cameraId}`,
		body
	);
	return data;
};

const remove = async (deviceId: number, cameraId: number): Promise<void> =>
	await axios.delete(`/v2/devices/${deviceId}/camera/${cameraId}`);

const getCommands = async (deviceId: number): Promise<ServiceResponse<CommandDto[]>> => {
	const { data } = await axios.get<ServiceResponse<CommandDto[]>>(`/v2/devices/${deviceId}/multimedia-commands`);
	return data;
};

const Service: CameraService = {
	get,
	create,
	update,
	delete: remove,
	getCommands,
};

export default Service;
